import React, {useEffect, useRef, useState} from "react";
import {LoadingMore} from "../Loading";
import LookingGlass from "../../assets/looking_glass.svg";
import {debouncedSearch} from "../../helpers/text";
import Cross from "../../assets/cross.svg";
import {useSelectorsCountriesQuery, useSelectorsShopsQuery} from "../../hooks/useSelectorsQuery";
import EmptyPlaceholder from "../_layout/EmptyPlaceholder";


export const ShopsList = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [searchText, setSearchText] = useState('');
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        refetch
    } = useSelectorsShopsQuery(
        searchQuery, null
    )

    // Данные не найдены, показать заглушку
    const isFirstPageEmpty = data?.pages[0]?.length === 0;

    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Скролл
        const handleScroll = () => {
            if (dropdownRef.current) {
                const {scrollTop, scrollHeight, clientHeight} = dropdownRef.current;
                if (scrollTop + clientHeight >= scrollHeight - 5) {
                    if (hasNextPage && !isFetchingNextPage) {
                        fetchNextPage();
                    }
                }
            }
        };

        // Назначаем обработчик скролла выпадающему списку
        if (dropdownRef.current) {
            dropdownRef.current.addEventListener('scroll', handleScroll);
        }

        return () => {
            // Убираем обработчик скролла у выпадающего спика
            if (dropdownRef.current) {
                dropdownRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

    const handleSearch = (value: string) => {
        setSearchQuery(value);
        refetch(); // Заново запрашиваем
    }
    useEffect(() => {
        refetch(); // Заново запрашиваем
    }, [searchQuery]);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(event.target.value);
        debouncedSearch(event.target.value, handleSearch);
    };

    // Очистка поиска в выпадающем списке
    const handleSearchClear = () => {
        setSearchText('');
        handleSearch('')
    };

    return <div className='w-full flex flex-col gap-5 rounded-b-lg overflow-hidden'>
        {/*ЗАГОЛОВОК СТРАНИЦЫ*/}
        <div className='flex justify-between mt-[26px]'>
            <div className='flex text-3xl my-auto'>
                Магазины
            </div>

            {/*ПОИСК*/}
            <div className='flex flex-row justify-center items-center gap-2'>
                <div className="relative bg-white p-3 rounded-lg h-12 flex flex-row justify-center items-center">
                    <input
                        className='search-input focus:outline-none'
                        placeholder="Поиск..."
                        value={searchText}
                        onChange={handleSearchChange}
                    />
                    {searchQuery ? <img
                            onClick={handleSearchClear}
                            alt=""
                            src={Cross}
                            className="cursor-pointer absolute !w-6 !h-6 !right-4"
                        /> :
                        <img
                            className='bg-white p-3 absolute cursor-pointer !right-2'
                            src={LookingGlass}
                            alt='search'
                        />}
                </div>
            </div>
        </div>


        <div className='w-full bg-white overflow-auto max-h-lvh rounded-t-lg flex flex-col grow h-full'>
            <div className="relative w-full flex flex-col h-full justify-between">
                <div className="w-full flex flex-row justify-start items-center px-5 h-16 shadow-below">
                    Название
                </div>
                {/*Список вариантов*/}
                <div className="overflow-y-auto h-full w-full" ref={dropdownRef}>
                    {!isFirstPageEmpty && data?.pages.map((page, i) => (
                        <React.Fragment key={i}>
                            {page.map((option: any) => (
                                <div
                                    className="h-16 px-5  flex flex-row justify-start items-center border-b border-b-gray cursor-pointer p-1"
                                    key={option.pk}
                                >
                                    {option.name}
                                </div>
                            ))}
                        </React.Fragment>
                    ))}
                    {isFirstPageEmpty && <EmptyPlaceholder text={'Список пуст'}/>}
                </div>
                <div className="absolute bottom-1 left-2">
                    {/*Индикатор подгрузки*/}
                    {isFetchingNextPage && <LoadingMore/>}
                </div>
            </div>
        </div>
    </div>
}